import { useEffect, useState } from 'react'
import './styles/HomePage.css'

const HomePage = () => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageError, setImageError] = useState(false)
  const [theme, setTheme] = useState<'light' | 'dark'>('light')

  useEffect(() => {
    // 시스템 테마 감지
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const savedTheme = localStorage.getItem('theme') as 'light' | 'dark' | null
    const initialTheme = savedTheme || (prefersDark ? 'dark' : 'light')
    setTheme(initialTheme)
    document.documentElement.setAttribute('data-theme', initialTheme)
  }, [])

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light'
    setTheme(newTheme)
    document.documentElement.setAttribute('data-theme', newTheme)
    localStorage.setItem('theme', newTheme)
    // 테마 변경 시 이미지 로딩 상태 초기화
    setImageLoaded(false)
    setImageError(false)
  }

  // 테마에 따른 로고 경로
  const logoSrc = theme === 'light' 
    ? '/assets/images/light/tait_logo.webp' 
    : '/assets/images/dark/tait_logo.webp'

  return (
    <div className="home-page">
      <button className="theme-toggle" onClick={toggleTheme} aria-label="테마 전환">
        {theme === 'light' ? (
          <svg className="theme-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" fill="currentColor"/>
          </svg>
        ) : (
          <svg className="theme-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="5" fill="currentColor"/>
            <path d="M12 1v2m0 18v2M4.22 4.22l1.42 1.42m12.72 12.72l1.42 1.42M1 12h2m18 0h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        )}
      </button>

      <main className="main-content">
        <div className="logo-container">
          {!imageError && (
            <img 
              key={logoSrc}
              src={logoSrc}
              alt="TaiT Logo" 
              className="logo-image"
              onLoad={() => {
                setImageLoaded(true)
              }}
              onError={() => {
                setImageError(true)
              }}
              style={{ 
                display: imageLoaded || !imageError ? 'block' : 'none'
              }}
            />
          )}
          {imageError && (
            <div className="fallback-logo">
              <div className="logo-triangle"></div>
              <div className="logo-text">A i</div>
            </div>
          )}
        </div>
      </main>

      <footer className="footer">
        <p>&copy; 2026 Netturn Inc. All rights reserved.</p>
      </footer>
    </div>
  )
}

export default HomePage
